module.exports = __webpack_public_path__ + "img/PodVirus.485ddc41.png";